import api from '@/api';

const { $pricing } = api;

export const { $products, $billingProps } = $pricing;
export const $procedure = 'Trámite';
